NtechApp.Nav = function($view/*, $snapTarget*/) {
    var me = this;

    this._$view = null;
    //this._$snapTarget = null;

    this._touchClickEvent = null;

    this._mainSelectList = null;
    this._messagesSelectList = null;
    this._notificationsSelectList = null;
    this._moreSelectList = null;

    this._searchForm = null;

    this._css = {
        ids: {
        },

        classes: {
            dropShadow: "dropShadow"
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;
        me._touchClickEvent = new NtechApp.TouchClickEvent();

        var $logoImg = me._$view.find(".logo .image img");

        if(!$("html").hasClass("hires")) {
            $logoImg.attr("src", $logoImg.attr("data-desktopImage"));
        }

        if(NtechApp.clientSettings.isLoggedIn) {
            var $snapToX = $("#mainNavigation").find(".navWrapper");

            me._mainSelectList = new NtechApp.SelectList(
                $("#mainNavSelectList"), me._$view.find("[data-navSelectListTrigger='main']"), -29, -18, $snapToX
            );

            me._messagesSelectList = new NtechApp.SelectList(
                $("#messagesNavSelectList"), me._$view.find("[data-navSelectListTrigger='messages']"), false, false, $snapToX
            );
            NtechApp.lockScroll($("#messagesNavSelectList").find(".scrollableList"));

            me._notificationsSelectList = new NtechApp.SelectList(
                $("#notificationsNavSelectList"), me._$view.find("[data-navSelectListTrigger='notifications']"), false, false, $snapToX
            );
            me._notificationsSelectList.restrictCloseOnBodyClick();
            NtechApp.lockScroll($("#notificationsNavSelectList").find(".scrollableList"));

            me._moreSelectList = new NtechApp.SelectList(
                $("#moreNavSelectList"), me._$view.find("[data-navSelectListTrigger='more']", false, false, $snapToX)
            );

            me._searchForm = new NtechApp.AccountSearchForm(
                me._$view.find("[data-searchInput]"),
                function() {
                    if(NtechApp.isMobile())
                        me._searchForm.getSearchAuto().forceInputMobileOverlayHide();
                    else if(NtechApp.isDesktop())
                        me._searchForm.getSearchAuto().unforceInputMobileOverlayHide();
                }
            );

            me._bindLoggedInEvents();
        }

        //me._$snapTarget = $snapTarget;

        //if(bowser.android && parseInt(bowser.osversion.replace(/\./g, ""), 10) < 444) {
        //    $("#mainNavigation").find(".logo .image img").attr("src", "/bundles/ntechclient/img/logofullScaleFix.jpg");
        //    var $fl = $("#footer").find(".logo");
        //    if($fl.length > 0)
        //        $fl.find("img").attr("src", "/bundles/ntechclient/img/bigFooter/footerLogoScaleFix.jpg");
        //}

        //me._updatePosition();
        //me._show();

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Nav.EVENT_WINDOW_RESIZE, function() {
            //setTimeout(function() { me._updatePosition(); }, 500);
            me._updateShadowVisibility();
        });

        $(document).on(NtechApp.Nav.EVENT_DOCUMENT_SCROLL, function() {
            me._updateShadowVisibility();
            //me._updatePosition();
        });

        $(window).on("load.NtechApp.Navigation", function() {
            me._updateShadowVisibility();
        });

        $(window).on(NtechApp.Router.ROUTE_CHANGE_EVENT, function(event, routeName) {
            if(routeName == NtechApp.Router.ROUTES.HOME)
                me._selectItem("home");
            else if(routeName == NtechApp.Router.ROUTES.ABOUT_US)
                me._selectItem("aboutus");
            else if(routeName == NtechApp.Router.ROUTES.COLLECTIONS)
                me._selectItem("products");
            else if(routeName == NtechApp.Router.ROUTES.CONTACT_US)
                me._selectItem("contactus");
            else if(routeName == NtechApp.Router.ROUTES.CLIENTS)
                me._selectItem("clients");
            else if(routeName == NtechApp.Router.ROUTES.ACCOUNT)
                me._selectItem("account");
        });

        //var scrollTopOffset = 15;
        //me._touchClickEvent.listen(me._$view.find(".menu .items"), ".item", function(event) {
        //    var scrollToId = $(event.target).attr("data-scrolltoid");
        //    $("html, body").animate({
        //        scrollTop: $("#" + scrollToId).offset().top - NtechApp.Navigation.MENU_PX_HEIGHT - scrollTopOffset
        //    }, 400);
        //});
    }

    this._bindLoggedInEvents = function() {
        var dispatchSelectListItemSelectEvent = function(e) {
            var $item = $(e.target).closest("[data-navSelectListTrigger]");
            var itemName = $item.attr("data-navSelectListTrigger");

            if(itemName == "main")
                var item = me._mainSelectList;
            else if(itemName == "more")
                var item = me._moreSelectList;
            else if(itemName == "messages")
                var item = me._messagesSelectList;
            else if(itemName == "notifications")
                var item = me._notificationsSelectList;

            $(me).trigger(NtechApp.Nav.EVENT_SELECTLIST_NAV_ITEM_SELECT, [itemName, item]);
        };

        me._touchClickEvent.listen(me._$view, "[data-navSelectListTrigger='main']", function(e) {
            e.preventDefault();

            me._mainSelectList.on();
            dispatchSelectListItemSelectEvent(e);

            return false;
        });

        me._touchClickEvent.listen(me._$view, "[data-navSelectListTrigger='more']", function(e) {
            e.preventDefault();

            me._moreSelectList.on();
            dispatchSelectListItemSelectEvent(e);

            return false;
        });

        me._touchClickEvent.listen(me._$view, "[data-navSelectListTrigger='messages']", function(e) {
            e.preventDefault();

            me._messagesSelectList.on();
            dispatchSelectListItemSelectEvent(e);

            return false;
        });

        me._touchClickEvent.listen(me._$view, "[data-navSelectListTrigger='notifications']", function(e) {
            e.preventDefault();

            me._notificationsSelectList.on();
            dispatchSelectListItemSelectEvent(e);

            return false;
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_CHAT_MESSAGES_VIEWED, function(e, chatId) {
            var $counter = me._$view.find("[data-notViewedChatsCount]");
            var currVal = parseInt($counter.text(), 10);

            if(currVal == 0)
                return;

            currVal--;
            $counter.text(currVal);
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_MARK_ALL_READ, function() {
            me._setNotViewedMessagesCount(0);
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_NOTIFICATIONS_VIEWED, function(e) {
            me._setNotViewedNotificationsCount(0);
        });

        me._bindLoggedInAjaxPollingEvents();
    }

    this._bindLoggedInAjaxPollingEvents = function() {
        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            me._setNotViewedMessagesCount(data.notViewedChatsCount);
            me._setNotViewedNotificationsCount(data.notViewedNotificationsCount);
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Nav.EVENT_WINDOW_RESIZE = "resize.NtechApp.Navigation";
NtechApp.Nav.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Navigation";

NtechApp.Nav.MENU_PX_HEIGHT = 120;

NtechApp.Nav.EVENT_SELECTLIST_NAV_ITEM_SELECT = "NtechApp.EventSelectListNavItemSelect";

NtechApp.Nav.prototype.getMessagesSelectList = function() {
    return this._messagesSelectList;
};

NtechApp.Nav.prototype.getNotificationsSelectList = function() {
    return this._notificationsSelectList;
};

NtechApp.Nav.prototype._selectItem = function(itemName) {
    this._$view.find(".menu .item").removeClass("selected");
    this._$view.find(".menu .item[data-item=" + itemName + "]").addClass("selected");
};

NtechApp.Nav.prototype._updateShadowVisibility = function() {
    if($(window).scrollTop() > 0) {
        if(this._$view.hasClass(this._css.classes.dropShadow))
            return;
        this._$view.addClass(this._css.classes.dropShadow);
    }
    else {
        if(!this._$view.hasClass(this._css.classes.dropShadow))
            return;
        this._$view.removeClass(this._css.classes.dropShadow);
    }
};

NtechApp.Nav.prototype._isSnapTargetInsideViewport = function() {
    var viewportY1 = window.pageYOffset || document.documentElement.scrollTop;
    var viewportY2 = viewportY1 + document.documentElement.clientHeight;

    var snapTargetY1 = this._$snapTarget.offset().top;
    var snapTargetY2 = snapTargetY1 + this._$snapTarget.outerHeight();

    if(viewportY1 > snapTargetY2 || viewportY2 < snapTargetY1)
        return false;
    else
        return true;
};

NtechApp.Nav.prototype._updatePosition = function() {
    //if(this._isSnapTargetInsideViewport()) {
    //    this._$view.css({
    //        position: "absolute",
    //        left: "0px",
    //        top: this._$snapTarget.offset().top + this._$snapTarget.outerHeight() + 1 + "px"
    //    });
    //}
    //else {
    //    this._$view.css({
    //        position: "fixed",
    //        left: "0px",
    //        top: "0px"
    //    });
    //}
};

NtechApp.Nav.prototype._show = function() {
    //this._$view.css("visibility", "visible");
};

NtechApp.Nav.prototype._setNotViewedMessagesCount = function(newCount) {
    var me = this;

    me._$view.find("[data-notViewedChatsCount]").text(newCount);
    if(newCount == 0)
        me._$view.find("[data-notViewedChatsCount]").parent().removeClass("selected");
    else
        me._$view.find("[data-notViewedChatsCount]").parent().addClass("selected");
};

NtechApp.Nav.prototype._setNotViewedNotificationsCount = function(newCount) {
    var me = this;

    me._$view.find("[data-notViewedNotificationsCount]").text(newCount);
    if(newCount == 0)
        me._$view.find("[data-notViewedNotificationsCount]").parent().removeClass("selected");
    else 
        me._$view.find("[data-notViewedNotificationsCount]").parent().addClass("selected");
};